import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "Welche Daten werden bei einer Bestellung erhoben?",
  answer: "Wir erheben ausschließlich notwendige Informationen wie Ihren Namen, die Lieferadresse und Zahlungsdetails, um Ihre Bestellung effizient abzuwickeln. Alle Daten werden nach höchsten Sicherheitsstandards verschlüsselt übertragen."
}, {
  question: "Wie sicher sind meine persönlichen Informationen?",
  answer: "Ihre Sicherheit hat Priorität. Wir nutzen moderne SSL-Verschlüsselung und speichern Daten auf zertifizierten Servern innerhalb der EU. Ein Zugriff durch unbefugte Dritte wird durch strikte interne Protokolle verhindert."
}, {
  question: "Werden meine Daten an Dritte weitergegeben?",
  answer: "Eine Weitergabe erfolgt nur an notwendige Dienstleister, wie Versandpartner oder Zahlungsabwickler. Wir verkaufen Ihre Daten niemals an Werbenetzwerke oder externe Marketing-Agenturen."
}, {
  question: "Wie kann ich mein Recht auf Auskunft wahrnehmen?",
  answer: "Sie haben jederzeit das Recht, eine Kopie Ihrer bei uns gespeicherten Daten anzufordern. Kontaktieren Sie dazu einfach unseren Datenschutzbeauftragten über das bereitgestellte Kontaktformular."
}, {
  question: "Verwendet diese Webseite Cookies zur Nachverfolgung?",
  answer: "Wir setzen funktionale Cookies ein, um den Warenkorb und Ihre Sitzung zu verwalten. Optionale Analyse-Cookies werden nur mit Ihrer ausdrücklichen Zustimmung aktiviert, um unser Angebot stetig zu verbessern."
}];
export default function FrequentlyAskedQuestions() {
  return <section data-section-id="225978" id="datenschutz" className="relative overflow-hidden bg-background text-foreground py-16 md:py-24">
      {/* Background Parallax Text */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden opacity-5">
        <span className="text-[15vw] font-bold font-default border-2 border-foreground text-transparent uppercase tracking-[0.2em] whitespace-nowrap">
          Privacy
        </span>
      </div>

      <div className="container relative z-10 mx-auto px-4 max-w-3xl">
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-5xl font-default font-bold text-foreground tracking-tight">
            Datenschutz & Sicherheit
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border border-b group transition-all duration-300 hover:bg-accent/30 hover:scale-[1.02] rounded-lg px-4">
              <AccordionTrigger className="font-default text-xl font-bold text-foreground hover:text-primary hover:no-underline transition-all duration-400 py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-foreground/80 text-lg leading-[1.6] font-sans pb-8 transition-all duration-400 ease-in-out">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}